import { ReadonlyURLSearchParams } from 'next/navigation';

export const birthdayFromDate = (birth?: string) => {
  if (!birth) {
    return { month: undefined, day: undefined };
  }

  const date = new Date(birth);

  if (Number.isNaN(date.getTime())) {
    return { month: undefined, day: undefined };
  }

  const month = String(date.getUTCMonth() + 1);
  const day = String(date.getUTCDate());

  return { month, day };
};

export const safeNumber = (value: string | null) => {
  if (!value) {
    return undefined;
  }

  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
};
export const getCleanParams = (
  params: URLSearchParams | ReadonlyURLSearchParams,
): string => {
  const filtered = new URLSearchParams();
  params.forEach((value, key) => {
    if (!key.startsWith('x-skippy-')) {
      filtered.set(key, value);
    }
  });
  return filtered.toString();
};
